<script>
	export let params = {};
	import Spinner from 'svelte-spinner';
	import app from '../web_feathers.js';
	const {perms, email, userID, checkedToken,checkingToken} = app;
	
	import { push} from 'svelte-spa-router';
	import { tick } from 'svelte';

	import {israelPhoneMobileNormalize, numberPrettify} from '../common_israel_mobiles.js';

	import Swal from 'sweetalert2';
	const SwalBootstrap = Swal.mixin({
		customClass: {
			confirmButton: 'btn btn-success mx-2',
			cancelButton: 'btn btn-danger mx-2' //we lost our spacing between buttons for some reason - set spacing on both sides
			},
		buttonsStyling: false
		})
	const SwalError = SwalBootstrap.mixin({
		icon: 'error'
		,allowOutsideClick: false
		});

	let error;
	let myLine = null;
	let loading = false;
	
	import Fa from 'svelte-fa'
	import { faCreditCard, faEdit,faFastForward,faMapMarkedAlt, faTools, faChevronRight, faSimCard, faTrash, faExchangeAlt, faInfo,faShoppingCart, faExclamationTriangle, faExclamation, faArrowTurnUp, faShare} from '@fortawesome/free-solid-svg-icons';
	
	
	import {formatDistanceToNow, parseISO} from 'date-fns';
	
	const SimActivations = app.service('sim_activations_user');
	
var linesToUpdate={};
var linesToUpdateVirtualNumbers={};
	async function init(){
		loading=true;
		error=false;
		const result = await SimActivations.get(params.lineID,{query:{showLinked:true}}).catch(e=>error=e.message).finally(()=>loading=false);
		if(error) return;
		myLine = result;

		if(myLine.linked){
			myLine.linked.forEach(function(line){
				linesToUpdate[line.id]=true;
				if(line.usa_number) linesToUpdateVirtualNumbers[line.id]=true;
				});
			}

		if(myLine.usa_number) linesToUpdateVirtualNumbers[params.lineID]=true;

		
		if(myLine.linked_bestfone){
			myLine.linked_bestfone.forEach(function(line){
				//linesToUpdateVirtualNumbers[line.id]=true;
				});
			}

		console.log(linesToUpdate);
		console.log(linesToUpdateVirtualNumbers);
		}
	
	init();

	//A card payment pays every month owed, not one (#114) - so say how many and how much before charging.
	import {monthsDue, amountDue, arrearsFor, arrearsHtml} from './arrears.js';
	$: arrears = arrearsFor(!myLine ? [] : [myLine, ...(myLine.linked||[]).filter(line=>linesToUpdate[line.id])]);
function compareEmail(a,b){
	if(a==b) return true;
	if(a && b && a.toUpperCase()==b.toUpperCase()) return true;
	return false;
	}

import CreditCardForm from '../creditCardEntry.svelte';
const CreateTranzilaToken = app.service('token-tranzila');
import CreateSumitToken from '../web_create_token_sumit.js';

var credit_card={};
var credit_card_valid;
var errors=false;

async function updateCreditCard(){
	console.log(linesToUpdate)
	console.log(linesToUpdateVirtualNumbers)
	if(!credit_card_valid) return SwalError.fire({text:'Please enter valid payment information.'});

	var newLast4 = credit_card.credit_card_number.slice(-4);
	var oldLast4 = myLine.cc_last4;

	var newExpiry = '' + credit_card.expiry_month + credit_card.expiry_year;
	var oldExpiry = myLine.cc_expiry;

	//if(newLast4==oldLast4 && newExpiry==oldExpiry) return SwalError.fire({text:'This is the same card already on file'});

	if(arrears.total>0){
		const ask = await SwalBootstrap.fire({
			title:`Charge ₪${arrears.total} now?`
			,html:arrearsHtml(arrears)
			,icon:'warning'
			,showCancelButton:true
			,confirmButtonText:`Save card & pay ₪${arrears.total}`
			});
		if(!ask.isConfirmed) return;
		}


	//const number = myLine.israel_number;
	//const line_id = myLine.id;
	loading=true;
	try{
		var TranzilaTK = CreateTranzilaToken.create({
				credit_card_number:credit_card.credit_card_number
				})
			.catch(function(){
				//toast('Error creating Tranzila token','error');
				});
		var sumitToken = CreateSumitToken(credit_card)
			.catch(function(){
				//toast('Error creating BestFone MOG/sumit token','error');
				});
		
		[TranzilaTK, sumitToken] = await Promise.all([TranzilaTK,sumitToken]);

		//Charges every month owed on each line - the server does that for a customer anyway (#114); an admin has to ask.
		var updates = {billing_update: true, billTotalDue: true, linesToUpdate, linesToUpdateVirtualNumbers};
		if(TranzilaTK) {
			updates.TranzilaTK = TranzilaTK;
			updates.cc_expiry= '' + credit_card.expiry_month + credit_card.expiry_year;; //MMYY for tranzila
			updates.security_code = credit_card.security_code
			}
		if(sumitToken) {
			updates.sumitToken = sumitToken;
			}

		//const listOfUpdates = 

		if(!TranzilaTK && !sumitToken) return SwalError.fire({text:'Error Saving Payment Information'});

		const paymentUpdate = await SimActivations.patch(myLine.id,updates);

		push('/line/'+myLine.id);
		await tick();
		let display = {icon:'success',html:'Payment Information Successfully Saved!',allowOutsideClick: false};
		if(paymentUpdate.message) display.html+= '\n<br>' + paymentUpdate.message;
		if(paymentUpdate.messageBestfone) display.html+= '\n<br>' + paymentUpdate.messageBestfone;
		SwalBootstrap.fire(display);
		}
	catch(error){
		if(error.message.startsWith('Tranzila 00')) SwalError.fire({title:'Credit Card Payment Failed'});
		SwalError.fire({text:error.message});
		}
	finally{
		loading=false;
		}
	}


function prettyPrintExpiry(date){
	if(!date) return '';
	let year=0;
	let month=0;
	if(date.length==6) {
		month = parseInt(date.substr(0,2));
		year = parseInt(date.substr(2,4));
		}
	if(date.length==4) {
		month = parseInt(date.substr(0,2));
		year = 2000+parseInt(date.substr(2,2));
		}
	if(year && month) return `${month}/${year}`;
	return date;
	}
</script>

<div class="container">

<div class="row">
	{#if error}
		<div class="alert alert-danger">
		{error}
		</div>
		{/if}
</div>

{#if myLine}
<div class="row justify-content-md-center">
	<div class="col-xs-12 col-md-8">
	{#if arrears.total>0}
		<div class="alert alert-warning">
			<Fa icon={faExclamationTriangle} /> <b>Submitting charges the new card ₪{arrears.total} right away.</b>
			{@html arrearsHtml(arrears)}
		</div>
	{/if}
	</div>
</div>

<br>
<center>
	Card currently on file: xxxx{myLine.TranzilaTK?.slice(-4)}, {prettyPrintExpiry(myLine.cc_expiry)}<br><br>
</center>

<div class="row justify-content-md-center">
<CreditCardForm
bind:credit_card_number={credit_card.credit_card_number} bind:valid={credit_card_valid}
bind:expiry_month={credit_card.expiry_month} bind:expiry_year={credit_card.expiry_year}
ask_security_code={false} bind:security_code={credit_card.security_code}
/>
</div>

<br>
<div class="row">
	<b>This will update the billing information for:</b>
	</div>

<div class="row ml-4">
	<input type="checkbox" class="form-check-input" checked onclick="this.checked=true;" id="self"><!-- can't disable this one!-->

	<label class="form-check-label" for="self">
		{#if myLine.billing_status!='ok'}
		<Fa icon={faExclamationTriangle} color="#dc3545"/>
		{/if}

	{myLine.bill} shekel/mo for {israelPhoneMobileNormalize(myLine.israel_number)}: {myLine.Customer_Name}
	{#if monthsDue(myLine)}<b class="text-danger">&mdash; owes {monthsDue(myLine)} month{monthsDue(myLine)==1?'':'s'}: ₪{amountDue(myLine)}</b>{/if}
	</label>
</div>

{#if myLine.usa_number}
<div class="row ml-4">
	<Fa icon={faShare} flip='vertical' translateY={.2} translateX={-1}/>
	<input type="checkbox" class="form-check-input ml-2" bind:checked={linesToUpdateVirtualNumbers[myLine.id]} id="checkbox-virtual-number">

	&nbsp;&nbsp;
	<label class="form-check-label" for="checkbox-virtual-number">
		{#if myLine.usa_number_paymentFailed}
		<Fa icon={faExclamationTriangle} color="#dc3545"/>
		{/if}

		{#if myLine.usa_number_charge}
			${myLine.usa_number_charge}/mo for
		{/if}
		{numberPrettify(myLine.usa_number)} virtual number (billed via BestFone.com)
	</label>
	</div>
	{/if}

<br>

{#if myLine.linked && myLine.linked.length}
	
<div class="row">
	<b>Related accounts to also update:</b>
	</div>


{#each myLine.linked as line}
	<div class="row ml-4">
	<input type="checkbox" bind:checked={linesToUpdate[line.id]} class="form-check-input" id={'checkbox-'+line.id}>

	<label class="form-check-label" for={'checkbox-'+line.id}>
		{#if line.billing_status!='ok'}
		<Fa icon={faExclamationTriangle} color="#dc3545"/>
		{/if}

	{line.bill} shekel/mo for {israelPhoneMobileNormalize(line.israel_number)}: {line.Customer_Name}
	{#if monthsDue(line)}<b class="text-danger">&mdash; owes {monthsDue(line)} month{monthsDue(line)==1?'':'s'}: ₪{amountDue(line)}</b>{/if}
	{#if compareEmail(line.email,myLine.email) && line.TranzilaTK == myLine.TranzilaTK}
		(same email and credit card)
	{:else if compareEmail(line.email,myLine.email)}
		(same email)
	{:else if line.TranzilaTK == myLine.TranzilaTK}
		(same credit card)
	{/if}
	</label>
	</div>



	{#if line.usa_number}
	<div class="row ml-4">
		<Fa icon={faShare} flip='vertical' translateY={.2} translateX={-1}/>
		<input type="checkbox" class="form-check-input ml-2" bind:checked={linesToUpdateVirtualNumbers[line.id]} id={"checkbox-virtual-number"+line.id}>
	
		&nbsp;&nbsp;
		<label class="form-check-label" for={"checkbox-virtual-number"+line.id}>
			{#if line.paymentFailed}
			<Fa icon={faExclamationTriangle} color="#dc3545"/>
			{/if}

			{#if line.usa_number_charge}
				${line.usa_number_charge}/mo for
			{/if}
			{numberPrettify(line.usa_number)} virtual number (billed via BestFone.com)
		</label>
		</div>
		{/if}





{/each}



{/if}



{#if myLine.linked_bestfone && myLine.linked_bestfone.length}
	
<div class="row">
	<b>Virtual Numbers or Calling Cards:</b>
	</div>

{#each myLine.linked_bestfone as line}
	<div class="row ml-4">
	<input type="checkbox" class="form-check-input" checked id={'checkbox-bestfone-'+line.did}>

	<label class="form-check-label" for={'checkbox-bestfone-'+line.did}>

	${line.charge}/mo for {numberPrettify(line.did)}

	</label>
	</div>

{/each}



{/if}

<br>
<div class="row justify-content-md-center">
<div class="col-sm-6 col-10 text-center">
<button class="btn btn-lg btn-success" disabled={loading} on:click={updateCreditCard}>
	Update Credit Card{#if arrears.total>0} &amp; pay ₪{arrears.total}{/if} <Fa icon={faFastForward}/>
	{#if loading} <Spinner/>{/if}
	</button>
<br>
<small>* Overdue lines are charged every month owed, right away.</small>
</div>
</div>

{/if}

</div>